<template>
  <div class="add-ticket-modal">
    <div class="add-ticket-modal-card">
      <h3 class="add-new-section-heading">
        Add New package
        <img
          @click="$emit('cancelAdd')"
          src="@/assets/icons/cross-small.svg"
          alt=""
          class="close-drawer"
        />
      </h3>
      <div class="input_wrap my-10">
        <h4 for="smInput" class="">
          Package Title (e.g. From Mumbai or Group tour etc.)
        </h4>
        <input
          v-model="ticketHeading"
          class="sm_input --dark my-10"
          type="text"
          placeholder="You can add package title eg. From Mumbai"
          autocomplete="off"
        />
      </div>

      <div class="trek-location-box" v-if="addNewLocation">
        <div class="trek-location-box-inner" @click.stop>
          <select-location-form
            @locationAdded="addLocation"
            @cancel="cancelAddLocation"
            :noBtn="false"
            :noHeader="false"
            :onlyFullAddress="true"
            :includeTimePicker="false"
            :prefillLocation="editPickupObj?.data || pickupPoints[0] || null"
          ></select-location-form>
        </div>
      </div>

      <div class="input_wrap my-10">
        <h4 for="smInput" class="">Pickup Points (Optional)</h4>
        <div class="input-note">
          You can add multiple pickup points for same city
        </div>

        <div class="selected-locations">
          <h5 v-if="pickupPoints && pickupPoints.length">Added Locations</h5>
          <div
            class="selected-locations__item"
            v-for="(location, i) in pickupPoints"
            :key="i"
          >
            <span class="selected-location__item-address"
              ><strong>{{ `${location.address.full_address}` }}</strong> <br />
            </span>
            <div class="selected-locations-item-actions">
              <img
                class="selected-location__item-edit"
                @click.stop="editPickup(location, i)"
                src="@/assets/icons/edit.svg"
                alt=""
              />
              <img
                class="selected-location__item-cross"
                @click="removeLocation(i)"
                src="@/assets/icons/cross-small.svg"
                alt=""
              />
            </div>
          </div>

          <div
            class="cta-wrap --add-more-location"
            v-if="!addNewLocation && (pickupPoints || pickupPoints.length)"
            @click="addNewLocation = true"
          >
            <div class="pill_btn --hollow">
              {{
                pickupPoints.length
                  ? "Add another location"
                  : "Add Pickup point"
              }}
            </div>
          </div>
        </div>

        <div class="input_wrap my-10">
          <h3 for="smInput" class="">Available Seats</h3>
          <input
            v-model="seatsAvailable"
            class="sm_input --dark my-10"
            type="number"
            placeholder="Enter no. of seats available for this package"
            autocomplete="off"
          />
        </div>

        <div class="input_wrap my-10">
          <h3 for="smInput" class="">Base Price</h3>
          <input
            v-model="ticketPrice"
            class="sm_input --dark my-10"
            type="number"
            placeholder="Enter Price per Package"
            autocomplete="off"
          />
        </div>

        <!-- Day-wise Pricing Section -->
        <div class="input_wrap my-10">
          <h3 class="">Day-wise Pricing Rules (Optional)</h3>
          <div class="input-note">
            Override base price for specific days or dates
          </div>

          <!-- Existing Rules -->
          <div class="rules-list" v-if="hasRules">
            <div
              class="rule-item-card"
              v-for="(rule, index) in pricingRules"
              :key="index"
            >
              <div class="rule-content">
                <h4>
                  Rule {{ index + 1 }}:
                  {{ rule.type === "weekdays" ? "Days" : "Dates" }}
                </h4>
                <div class="rule-details">
                  <span v-if="rule.type === 'weekdays'">
                    {{ formatWeekdays(rule.selection) }}
                  </span>
                  <span v-else>
                    {{ formatDates(rule.selection) }}
                  </span>
                  <strong class="rule-price">₹{{ rule.price }}</strong>
                </div>
              </div>
              <div class="rule-actions">
                <img
                  class="rule-action-btn"
                  @click="editRule(index)"
                  src="@/assets/icons/edit.svg"
                  alt=""
                />
                <img
                  class="rule-action-btn"
                  @click="removeRule(index)"
                  src="@/assets/icons/cross-small.svg"
                  alt=""
                />
              </div>
            </div>
          </div>

          <!-- Add New Rule Form -->
          <div v-if="showNewRule" class="new-rule-card">
            <h4>
              {{
                editingRuleIndex !== null ? "Edit Rule" : "Add New Pricing Rule"
              }}
            </h4>

            <!-- Rule Type Selection -->
            <div class="rule-type-selection">
              <div class="discount-types">
                <div
                  class="discount-types-option"
                  :class="{ '--selected': newRule.type === 'weekdays' }"
                  @click="newRule.type = 'weekdays'"
                >
                  Days of Week
                </div>
                <div
                  class="discount-types-option"
                  :class="{ '--selected': newRule.type === 'special_dates' }"
                  @click="newRule.type = 'special_dates'"
                >
                  Specific Dates
                </div>
              </div>
            </div>

            <!-- Weekdays Selection -->
            <div
              v-if="newRule.type === 'weekdays'"
              class="weekdays-selection"
              :class="editingRuleIndex !== null ? '--disabled' : ''"
            >
              <h5>Select Days</h5>
              <div class="weekdays-grid">
                <div
                  v-for="day in weekdays"
                  :key="day.key"
                  class="weekday-option"
                  :class="{
                    '--selected': newRule.selectedDays.includes(day.key),
                    '--disabled':
                      day_wise_pricing.weekdays[day.key] &&
                      editingRuleIndex === null,
                  }"
                  @click="toggleWeekday(day.key)"
                >
                  {{ day.label }}
                </div>
              </div>
            </div>

            <!-- Date Selection -->
            <div
              v-if="newRule.type === 'special_dates'"
              class="dates-selection"
              :class="editingRuleIndex !== null ? '--disabled' : ''"
            >
              <h5>Select Dates</h5>
              <multi-dates-picker
                class="my-10"
                @datesSelected="selectRuleDates"
                :selectedDates="newRule.selectedDates"
              ></multi-dates-picker>
            </div>

            <!-- Price Input -->
            <div class="input_wrap my-10">
              <h5>
                Price for Selected
                {{ newRule.type === "weekdays" ? "Days" : "Dates" }}
              </h5>
              <input
                v-model="newRule.price"
                class="sm_input --dark"
                type="number"
                placeholder="Enter price"
                autocomplete="off"
              />
            </div>

            <!-- Form Actions -->
            <div class="split_btns">
              <div
                class="pill_btn --small"
                :class="{ '--disabled': !canSaveRule }"
                @click="saveRule"
              >
                {{ editingRuleIndex !== null ? "Update Rule" : "Save Rule" }}
              </div>
              <div
                class="pill_btn --small --hollow --border-less"
                @click="cancelRule"
              >
                Cancel
              </div>
            </div>
          </div>

          <!-- Add Rule Button -->
          <div
            v-if="!showNewRule"
            class="cta-wrap --add-more-location"
            @click="showNewRule = true"
          >
            <div class="pill_btn --hollow">Add Pricing Rule</div>
          </div>
        </div>

        <div class="split_btns my-30">
          <div
            class="pill_btn --small"
            :class="{
              '--disabled': loadCreate || !ticketHeading || !ticketPrice,
            }"
            @click="createTicket()"
          >
            Save this ticket
          </div>
          <div
            class="pill_btn --small --hollow --border-less"
            @click="$emit('cancelAdd')"
          >
            Cancel
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectLocationForm from "@/components/inputs/SelectLocationForm.vue";
import MultiDatesPicker from "@/components/inputs/MultiDates.vue";
import computedMixin from "@/mixins/computedMixin";

export default {
  mixins: [computedMixin],
  components: {
    SelectLocationForm,
    MultiDatesPicker,
  },
  props: ["templateId", "editTicket"],
  data() {
    return {
      loadCreate: false,
      ticketHeading: null,
      newLocation: {},
      pickupPoints: [],
      addNewLocation: false,
      seatsAvailable: null,
      ticketPrice: null,
      editPickupObj: null,

      // Day-wise pricing
      day_wise_pricing: {
        special_dates: {},
        weekdays: {
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null,
        },
      },

      // Rule management
      showNewRule: false,
      editingRuleIndex: null,
      originalRule: null,
      newRule: {
        type: "weekdays",
        selectedDays: [],
        selectedDates: [],
        price: null,
      },

      weekdays: [
        { key: "monday", label: "Mon" },
        { key: "tuesday", label: "Tue" },
        { key: "wednesday", label: "Wed" },
        { key: "thursday", label: "Thu" },
        { key: "friday", label: "Fri" },
        { key: "saturday", label: "Sat" },
        { key: "sunday", label: "Sun" },
      ],
    };
  },

  computed: {
    hasRules() {
      return this.pricingRules.length > 0;
    },

    pricingRules() {
      const rules = [];

      // Convert weekdays to rules
      Object.keys(this.day_wise_pricing.weekdays).forEach((day) => {
        const price = this.day_wise_pricing.weekdays[day];
        if (price) {
          // Find if this price already exists in rules
          let existingRule = rules.find(
            (r) => r.type === "weekdays" && r.price === price
          );
          if (existingRule) {
            existingRule.selection.push(day);
          } else {
            rules.push({
              type: "weekdays",
              selection: [day],
              price: price,
            });
          }
        }
      });

      // Convert special_dates to rules
      Object.keys(this.day_wise_pricing.special_dates).forEach((date) => {
        const price = this.day_wise_pricing.special_dates[date];
        if (price) {
          let existingRule = rules.find(
            (r) => r.type === "special_dates" && r.price === price
          );
          if (existingRule) {
            existingRule.selection.push(date);
          } else {
            rules.push({
              type: "special_dates",
              selection: [date],
              price: price,
            });
          }
        }
      });

      return rules;
    },

    canSaveRule() {
      if (!this.newRule.price || this.newRule.price <= 0) return false;

      if (this.newRule.type === "weekdays") {
        return this.newRule.selectedDays.length > 0;
      } else {
        return this.newRule.selectedDates.length > 0;
      }
    },
  },

  mounted() {
    this.prefill();
  },

  methods: {
    prefill() {
      if (this.editTicket) {
        this.ticketHeading = this.editTicket.ticket_heading;
        this.pickupPoints = this.editTicket.pickup_points || [];
        this.ticketPrice = this.editTicket.price_value;
        this.seatsAvailable = this.editTicket.seats_available;
        this.addNewLocation = false;

        if (this.editTicket.day_wise_pricing) {
          this.day_wise_pricing = { ...this.editTicket.day_wise_pricing };
        }
      }
    },

    cancelAddLocation() {
      this.addNewLocation = false;
      this.editPickupObj = false;
    },

    addLocation(location) {
      this.addNewLocation = false;
      if (this.editPickupObj) {
        this.pickupPoints.splice(this.editPickupObj.index, 1);
        this.pickupPoints.splice(this.editPickupObj.index, 0, location);
        this.editPickupObj = null;
      } else {
        this.pickupPoints.push(location);
      }
    },

    removeLocation(index) {
      this.pickupPoints.splice(index, 1);
    },

    editPickup(data, i) {
      this.editPickupObj = {
        index: i,
        data: data,
      };
      this.addNewLocation = true;
    },

    // Rule management methods
    toggleWeekday(day) {
      const index = this.newRule.selectedDays.indexOf(day);
      if (index > -1) {
        this.newRule.selectedDays.splice(index, 1);
      } else {
        this.newRule.selectedDays.push(day);
      }
    },

    selectRuleDates(dates) {
      this.newRule.selectedDates = dates || [];
    },

    saveRule() {
      if (!this.canSaveRule) return;

      const price = parseFloat(this.newRule.price);

      if (this.newRule.type === "weekdays") {
        // Add weekday rules
        this.newRule.selectedDays.forEach((day) => {
          this.day_wise_pricing.weekdays[day] = price;
        });
      } else {
        // Add special date rules
        this.newRule.selectedDates.forEach((date) => {
          // Format date as DD-MM-YYYY
          const formattedDate = this.formatDateForStorage(date, true);
          this.day_wise_pricing.special_dates[formattedDate] = price;
        });
      }

      this.cancelRule();
    },

    editRule(index) {
      const rule = this.pricingRules[index];
      this.editingRuleIndex = index;
      this.showNewRule = true;

      this.newRule = {
        type: rule.type,
        selectedDays: rule.type === "weekdays" ? [...rule.selection] : [],
        selectedDates: rule.type === "special_dates" ? [...rule.selection] : [],
        price: rule.price,
      };
    },

    removeRule(index) {
      const rule = this.pricingRules[index];

      if (rule.type === "weekdays") {
        rule.selection.forEach((day) => {
          this.day_wise_pricing.weekdays[day] = null;
        });
      } else {
        rule.selection.forEach((date) => {
          delete this.day_wise_pricing.special_dates[date];
        });
      }
    },

    cancelRule() {
      this.showNewRule = false;
      this.editingRuleIndex = null;
      this.newRule = {
        type: "weekdays",
        selectedDays: [],
        selectedDates: [],
        price: null,
      };
    },

    formatWeekdays(days) {
      return days
        .map((day) => day.charAt(0).toUpperCase() + day.slice(1))
        .join(", ");
    },

    formatDates(dates) {
      const formattedDates = dates.map((d) => {
        console.log(d, "formatting date");
        return this.formatDateForStorage(new Date(d), false);
      });
      return formattedDates.join(", ");
    },

    formatDateForStorage(date, forStorage) {
      // Convert date to DD-MM-YYYY format
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      if (forStorage) {
        return `${year}-${month}-${day}`;
      }
      return `${day}-${month}-${year}`;
    },

    async createTicket() {
      this.loadCreate = true;
      const ticket = {
        ticket_heading: this.ticketHeading,
        pickup_points: this.pickupPoints,
        seats_available: this.seatsAvailable,
        price_value: this.ticketPrice,
        day_wise_pricing: this.day_wise_pricing,
      };

      if (this.editTicket && this.editTicket._id) {
        ticket._id = this.editTicket._id;
      }

      this.$emit("ticketAdded", ticket);
      this.loadCreate = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.add-ticket-modal {
  padding: $sp-md;
}

.add-new-section-heading {
  font-size: $txt-lg;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: $sp-xl;
  .close-drawer {
    width: $icon-w-md;
  }
}

.trek-location-box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: $primary-bg-color-backdrop;
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $sp-md;
  box-sizing: border-box;
}

.trek-location-box-inner {
  padding: $sp-sm;
  border-radius: $br-sm;
  border: 1px dashed $tertiary-text-color;
  background-color: $primary-bg-color;
  margin: $sp-md 0 $sp-lg;
}

.selected-locations {
  margin: $sp-md 0;
  .selected-locations__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: $sp-md;
    background-color: $primary-bg-color;
    padding: $sp-sm;
    border-radius: $br-sm;
    margin: $sp-sm 0;
    .selected-location__item-address {
      font-size: $txt-sm;
      white-space: pre-wrap;
    }
    .selected-locations-item-actions {
      display: flex;
      align-items: center;
      gap: $sp-md;
      .selected-location__item-edit {
        width: $icon-w-xs;
        cursor: pointer;
      }
      .selected-location__item-cross {
        width: $icon-w-sm;
        cursor: pointer;
      }
    }
  }
}

.--add-more-location {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: $sp-sm;

  .pill_btn {
    font-size: $txt-xs;
  }
}

// Pricing Rules Styles
.rules-list {
  margin: $sp-md 0;
}

.rule-item-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: $primary-bg-color;
  padding: $sp-sm;
  border-radius: $br-sm;
  margin: $sp-sm 0;
  border: 1px solid $tertiary-text-color;

  .rule-content {
    flex: 1;

    h4 {
      font-size: $txt-sm;
      margin-bottom: $sp-xs;
    }

    .rule-details {
      display: flex;
      align-items: center;
      gap: $sp-md;
      font-size: $txt-xs;
      color: $secondary-text-color;

      .rule-price {
        color: #10b981;
        font-size: $txt-sm;
      }
    }
  }

  .rule-actions {
    display: flex;
    gap: $sp-sm;

    .rule-action-btn {
      width: $icon-w-xs;
      cursor: pointer;
    }
  }
}

.new-rule-card {
  margin-top: $sp-sm;
  border: 1px dashed $tertiary-text-color;
  border-radius: $br-sm;
  padding: $sp-sm;
  background-color: $secondary-bg-color;
}

.rule-type-selection {
  margin: $sp-md 0;
}

.weekdays-selection {
  margin: $sp-md 0;

  .weekdays-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: $sp-xs;
    margin: $sp-sm 0;
  }

  .weekday-option {
    padding: $sp-sm;
    text-align: center;
    border: 1px solid $tertiary-text-color;
    border-radius: $br-sm;
    cursor: pointer;
    font-size: $txt-xs;
    background-color: $primary-bg-color;

    &:hover {
      border-color: $secondary-text-color;
    }

    &.--selected {
      background-color: $primary-text-color;
      color: $primary-bg-color;
      border-color: $primary-text-color;
    }
  }
}

.dates-selection {
  margin: $sp-md 0;
}

.discount-types {
  display: flex;
  align-items: center;
  gap: $sp-sm;

  .discount-types-option {
    padding: $sp-sm $sp-md;
    border-radius: $br-sm;
    font-size: $txt-xs;
    border: 1px dashed $tertiary-text-color;
    background-color: $secondary-bg-color-hover;
    color: $primary-text-color;
    cursor: pointer;

    &:hover {
      border: 1px dashed $secondary-text-color;
      color: $secondary-text-color;
    }

    &.--selected {
      border: 1px dashed $primary-text-color;
      color: $primary-text-color;
      background-color: $primary-bg-color;
    }
  }
}
</style>
